import { render, staticRenderFns } from "./Entity.vue?vue&type=template&id=1a8a94b4&scoped=true"
import script from "./Entity.vue?vue&type=script&lang=js"
export * from "./Entity.vue?vue&type=script&lang=js"
import style0 from "./Entity.vue?vue&type=style&index=0&id=1a8a94b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8a94b4",
  null
  
)

export default component.exports